import { siteCopy } from "../content";
import { communityCopy } from "../content/community";
import styles from "./AppFooter.module.css";

const copy = siteCopy.footer;

type AppFooterProps = {
  onRoomList: () => void;
  onAbout: () => void;
  onCommunity: () => void;
  onPrivacy: () => void;
  onNewsletter: () => void;
  onLeave: () => void;
};

export function AppFooter({
  onRoomList,
  onAbout,
  onCommunity,
  onPrivacy,
  onNewsletter,
  onLeave,
}: AppFooterProps) {
  return (
    <footer className={styles.footer}>
      <div className={styles.brand}>
        <img
          src="/images/scene/leonie-logo.webp"
          width="64"
          height="64"
          loading="lazy"
          alt=""
        />
        <div>
          <strong>Soul Surf Shack</strong>
          <span>{copy.tagline}</span>
        </div>
      </div>

      <nav aria-label="Meer over de Soul Surf Shack">
        {/*
          The text alternative to the hotspots. It lives down here rather than
          under the scene, so it takes none of the room's height.
        */}
        <button type="button" onClick={onRoomList}>
          {siteCopy.scene.objectMenuLabel}
        </button>
        <button type="button" onClick={onAbout}>
          {copy.aboutLabel}
        </button>
        {/*
          Fase 1 reaches the deck from the footer rather than from a sixth
          hotspot: a hotspot needs its own artwork and separate desktop and
          mobile coordinates, and neither exists yet.
        */}
        <button type="button" onClick={onCommunity}>
          {communityCopy.invitation.title}
        </button>
        <button type="button" onClick={onNewsletter}>
          {copy.newsletterLabel}
        </button>
        <button type="button" onClick={onPrivacy}>
          {copy.privacyLabel}
        </button>
        <button type="button" onClick={onLeave}>
          {copy.leaveLabel}
        </button>
        <a
          href="https://soulsurferleonie.substack.com/"
          target="_blank"
          rel="noreferrer"
        >
          {copy.substackLabel} <span aria-hidden="true">↗</span>
        </a>
      </nav>
    </footer>
  );
}
